export enum WidgetComponentType
{
    ActivityComponent,
    ChartComponent,
    TableComponent,
    TrendComponent,
    MultiLineChartWidgetComponent
}